module.exports = __webpack_public_path__ + "static/img/menu1.7df6b105.png";